import React, { useState, Fragment } from 'react';
import { connect } from "react-redux";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import Common from '../Common';
import { Button, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loading from '../../Common/Loading';
import { useEffect } from 'react';
import ListTable from '../../Common/ListTable';
import { populateFormDetails,getContactLinkedData, confirmBox, showToast, getSelectedFormIds, isMobile, prepareCustomTableData,getPerRecordOption, checkIsAdmin, translateContent, handleErrorResponse,getDeleteIcon, getWarningIcon, formatNumberShort ,getSessionValue,parseJSON} from '../../Common/Appcommon';
import aiData from "../../assets/utils/images/agent_no_records.png"
import NoRecordFound from '../Common/NoRecordFound';
import FormModal from './FormModal';
import "./assets/index.css";
import ListViewHeader from '../Common/ListViewHeader';
import requestApiService from '../../services/requestApi.service';
import Select from "react-select";
import MassUpdateModal from './MassUpdateModal';
import { ContactStatusOptions } from './Constant';
import CustomListTable from '../../Common/CustomListTable';
// import diamond_exclamation_img from "../../assets/utils/images/diamond-exclamation.png";
import dark_diamond_exclamation_img from "../../assets/utils/images/diamond-exclamation-dark.png";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";

const Contacts = (props) => {
    let contactform = "table_74";
    const [showLoading, setShowLoading] = useState(false);
    const [isOpenForm, setOpenForm] = useState(false);
    const [isNew, setIsNew] = useState(true);
    let [formD, setFormDetail] = useState([]);
    const [data, setData] = useState([]);
    const [column, setColumns] = useState([]);
    const [searchStr, setSearchString] = useState('');
    const [formId, setFormId] = useState("");
    const [dataRow, setDataRow] = useState({});
    const [selectedRows, setSelectedRows] = useState("");
    const [clearRows, setClearRows] = useState(false);
    const [isMoreOption, setIsMoreOptionNeeded] = useState(false);
    const allStatus = ContactStatusOptions;
    const [defaultStatus, setDefaultStatus] = useState();
    const [defTagOptions, setdefTagOptions] = useState();
    const [tagOptions, setTagOptions] = useState({ value: 'All', label: 'All' });
    const [deflistOptions, setdefListOptions] = useState();
    const [listOptions, setListOptions] = useState({});
    const [customFilter, setCustomFilter] = useState("");
    const [isMassUpdate, setIsMassUpdate] = useState(false);
    const [totalRecordsCount, setTotalRecordsCount] = useState(0);
    const [listTableCurPage,setCurrentPage] = useState(1);
    const [offset,setOffset] = useState(0);
    const [recordsPerPage,setRecordPerPage] = useState(10);
    const [isAdmin ,setAdmin] = useState(false);
    const [maxCount, setmaxCount] = useState(0);
    let isAddContact = true;

    let appid = "";
    let data_row = {};
    let { accountInfo } = props;
    let leadMenus = getSessionValue("leadMenulist");
    if(leadMenus){
        leadMenus = parseJSON(leadMenus);
    }
    if (accountInfo !== undefined) {
        data_row = accountInfo.data_row;
        appid = data_row.appid;
    }

    useEffect(() => {
        const loadContacts = async () => {
            setShowLoading(true);
            await fetchContacts("");
        };
        loadContacts();
    }, []);

    const loadOtherLinkedData = async (formname) => {
        let params = {
            ENTITY: "WHATSAPPPROCESS",
            OPERATION: "GET_LINKED_DATA",
            FORMNAME: formname,
            LINKED_FORMS: ['table_81', 'table_82']
        };
        let linkedData = [];
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            linkedData = data;
        }
        return linkedData;
    }

    const loadTagListData = async (tagData, idvalue, data, label) => {
        let contactTag = tagData !== undefined && tagData !== null && tagData !== "" ? tagData[idvalue] : "";
        let tagDataValue = "";
        if (contactTag !== undefined && contactTag !== null && contactTag !== "" && contactTag.length > 0) {
            tagDataValue = contactTag.map((tag, index) => {

                return (
                    <div key={index} className={`badge badge-info`}>
                        {tag}
                    </div>
                );
            });

        }
        if (tagDataValue !== "") {
            tagDataValue = (
                <div className="sb-sts-btn-grp sb-sts-tbl">
                    {tagDataValue}
                </div>

            )
        }
        data[label] = tagDataValue;
        return data;
    }

    const fetchContacts = async (searchValue, advSearch = "",pageLimit = 10,pageOffset = 0) => {
        let updatedFilter = "";
        for (let key in advSearch) {
            if (advSearch[key]) {
                updatedFilter += advSearch[key];
            }
        }
        setShowLoading(true);
        let formDetail = await populateFormDetails(contactform, appid);
        setFormDetail(formDetail);
        // let { templates, selectedTemplate } = await getTemplatesFormDetails(formDetail, "Recently Created");
        // let tempData = await loadFormData(contactform, formDetail, selectedTemplate, appid, advSearch, true, [], searchValue);
        let params = {
            'ENTITY': "AIPROCESSOR",
            'OPERATION': "GET_CONTACT_DATA",
            'FILTER_COND':updatedFilter,
            'LIMIT' : pageLimit,
            'OFFSET' : pageOffset
        };
        let usersData = await requestApiService.processServerRequest(params, "WebV2");
        if (usersData.issuccess) {
            let linkedData = await loadOtherLinkedData(contactform);
            let tagData = linkedData['table_82'];
            let listData = linkedData['table_81'];
            // let { formData, listFields } = usersData;
            let data = usersData.data;
            let formData = data[0] ?? [];
            let listFields = data[1] ?? [];
            setTotalRecordsCount(data[2]);
            setmaxCount(data[3]);

            // let tagFd = await loadDefaultFieldDetail("Tags", "Tags");
            // let listFd = await loadDefaultFieldDetail("Lists", "Lists");
            // let cfieldDetails = formDetail[1];
            // listFields.push(tagFd);
            // listFields.push(listFd);
            // cfieldDetails.push(tagFd);
            // cfieldDetails.push(listFd);
            // let nameLabelMapper = await prepareLabelNameMapper(cfieldDetails);
            for (let fi = 0; fi < formData.length; fi++) {
                let data = formData[fi];
                let idvalue = data[contactform + "_id"];
                let dataValue = data['VM_Contact_Status'];
                // let dataValue = data[accountLabel];

                if (dataValue !== undefined && dataValue !== null && dataValue !== "") {
                    let bclass = "sub-sts-active";
                    if (dataValue.toLowerCase() === "unsubscribed") {
                        bclass = "sub-sts-pym-fail";
                    }
                    dataValue = (
                        <div className={`badge ${bclass}`}>
                            {dataValue}
                        </div>
                    );
                }
                data = await loadTagListData(tagData, idvalue, data, "Tags");
                data = await loadTagListData(listData, idvalue, data, "Lists");
                data['VM_Contact_Status'] = dataValue;
            }
            let adminProfile = await checkIsAdmin();
            setAdmin(adminProfile);
            if (searchValue === "") {
                const options = await getContactLinkedData("table_81");
                setListOptions(options);
                const tags = await getContactLinkedData("table_82");
                setTagOptions(tags);
            }
            let tableData = await prepareCustomTableData(formData, listFields, adminProfile ? true : false, false,onEditContact);
            // let tableData = await prepareTableData(formData, listFields, false, cfieldDetails, true, onEditContact);
            setData(tableData.data);
            setClearRows(true);
            setIsMoreOptionNeeded(false);
            setColumns(tableData.columns);
            setShowLoading(false);
        }
    }
    const handleChange = async (updatedOffset, page, perPageRecord) => {
        setOffset(updatedOffset);
        setCurrentPage(page) 
        setRecordPerPage(perPageRecord);
        setClearRows(false);
        setIsMoreOptionNeeded(false);
        await fetchContacts("",customFilter,perPageRecord,updatedOffset);       
    }
    const onEditContact = (row) => {
        let id = row.data_row[contactform + "_id"];
        setDataRow(row.data_row);
        setFormId(id);
        setIsNew(false);
        setOpenForm(true);
        setClearRows(false);
        setIsMoreOptionNeeded(false);
    }

    const onAddContact = async() => {
        if(parseInt(totalRecordsCount)+1 > maxCount){
            let maxValue = await formatNumberShort(maxCount);
            let confirm = await confirmBox(translateContent("vm.contact.limit.msg",{'limit':maxValue}), '', getWarningIcon(), 'OK', 'Cancel',false);
            // handleErrorResponse(translateContent("vm.contact.limit.msg"));
            // let isConfirm = await confirmBox()
            return;
        }
        setDataRow({});
        setFormId("");
        setIsNew(true);
        toggleModal();
        setClearRows(false);
        setIsMoreOptionNeeded(false);
    }
    const toggleModal = async (isRefresh = false) => {
        setOpenForm(!isOpenForm);
        setClearRows(true);
        setIsMoreOptionNeeded(false);

        if (isRefresh) {
            setClearRows(true);
            setIsMoreOptionNeeded(false);    
            await fetchContacts("",customFilter,recordsPerPage,offset);
        }
    };
    const handleInputChange = (e) => {
        let value = e.target.value;
        setSearchString(value);
        setShowLoading(true);
        if (value !== undefined && value !== null) {
            fetchContacts(value);
        }
    };

    const getHeaderTitleBody = (isAddContact) => {
        if (!isAddContact) {
            return (
                <div className = 'd-flex align-items-center'>
                    <div className='d-flex align-center m-2'>
                        <div className=''>
                            <Button size="lg" className='theme-bg-g btn-hover-shine' color="dark" onClick={onAddContact}><FontAwesomeIcon icon={faPlus} /> &nbsp;Add Lead</Button>
                        </div>
                        {showLeadMenus()}
                    </div>
                </div>
            )
        } else {
            return (
                <div className = {isMobile() ? 'd-flex justify-content-end align-items-center mb-2' : 'd-flex align-items-center'}>
                    <div>
                        <Button size="lg" className='theme-bg-g btn-hover-shine' color="dark" onClick={onAddContact}> <FontAwesomeIcon icon={faPlus} /> &nbsp;Add Lead</Button>
                    </div>
                    {showLeadMenus()}
                </div>
               
            )
        }
    }

    const onDeleteContacts = async (selectableRows) => {
        let rowCount = selectableRows.length;
        let confirm = await confirmBox(translateContent("vm.contact.delete.confirm.msg",{count: rowCount,record:rowCount > 1 ?"records" : "record"}), translateContent("vm.delete.confirm.msg"), getDeleteIcon() , 'Delete', 'Cancel');
        if (!confirm) {
            rowCount = 0;
            return;
        }

        let formIds = getSelectedFormIds(selectableRows);
        if (rowCount > 0) {
            let params = {
                "ENTITY": "FORMPROCESS",
                "OPERATION": "DELETE",
                "FORMNAME": contactform,
                "MODULENAME": "Contacts",
                "FORMTYPE": "",
                "Check Reference": true,
                "FORM_INPUTFIELDS": formIds,
            };
            let response = await requestApiService.processServerRequest(params, "WebV2");
            if (response.issuccess) {
                setClearRows(true);
                setSelectedRows('');
                setIsMoreOptionNeeded(false);
                await fetchContacts("",customFilter,recordsPerPage,offset);
                showToast(translateContent("vm.contact.delete.msg"));
            }
        }
    }

    const onUpdateContacts = () => {
        setIsMassUpdate(true);
    }

    const toggleMassUpdatePanel = async (isRefresh = false) => {
        setIsMassUpdate(!isMassUpdate);
        if (isRefresh) {
            await fetchContacts("",customFilter,recordsPerPage,offset);
            setClearRows(true);
            setSelectedRows('');
            setIsMoreOptionNeeded(false);
            setTimeout(() => {
                setClearRows(false);
            }, 500)
        }
    }

    const onStatusChange = async (selectedOption, value) => {
        let newAdFilterSearch = "";
        let customList = [];
        let customStatus = "";
        let updatedFilter = { ...customFilter };
        if (value !== undefined && value !== null && value !== "") {
            if (value === "contact_status") {
                setDefaultStatus(selectedOption);
                if(selectedOption !== undefined && selectedOption !== null){
                    let contactStatus = selectedOption.value !== undefined && selectedOption.value !== null && selectedOption.value !== "" ? selectedOption.value : "";
                    newAdFilterSearch = "nondate@table_74@VM_Contact_Status@is@"+contactStatus+"@AND#";
                }
                updatedFilter["contact_status"] = newAdFilterSearch;
            } else if (value === "list_status") {
                setdefListOptions(selectedOption);
                if(selectedOption !== undefined && selectedOption !== null){
                    customList.push(selectedOption); 
                    customStatus += `linkspl@List@table_81@includes@${JSON.stringify(customList)}@AND#`; 
                }else{
                    customStatus += ""; 
                }
                updatedFilter["list_status"] = customStatus;
            } else if (value === "tag_status") {
                setdefTagOptions(selectedOption);
                if(selectedOption !== undefined && selectedOption !== null){
                    customList.push(selectedOption); 
                    customStatus += `linkspl@Tag@table_82@includes@${JSON.stringify(customList)}@AND#`;
                }else{
                    customStatus += ""; 
                }
                updatedFilter["tag_status"] = customStatus;
            }
            setCustomFilter(updatedFilter);
            fetchContacts("", updatedFilter,recordsPerPage,offset);
        }
    };

    const onMenuChange = (url) => {
        window.location.href = url;
    }

    const showLeadMenus = () =>{
        return(
            <>
                <UncontrolledDropdown>
                    <DropdownToggle className="agent-test-btn mb-2">
                    <button className='dot-icon mt-2'>
                        <i class="fi fi-bs-menu-dots-vertical"></i>
                    </button>
                    </DropdownToggle>
                    <DropdownMenu className="agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                        {
                            leadMenus && 
                            leadMenus.map((option, index) => {
                                let label = option.label;
                                let value = option.to;
                                return (
                                    <DropdownItem 
                                        className="dropdown-list" 
                                        onClick={e => onMenuChange(value)}
                                    >
                                        <span>
                                            {label}
                                        </span>
                                    </DropdownItem>
                                )
                            })
                        }
                    </DropdownMenu>
                </UncontrolledDropdown>            
            </>
        )
    }

    const showListandTagMenus = () =>{
        return(
            <>
                <UncontrolledDropdown>
                    <DropdownToggle className="agent-test-btn">
                        <i class="fi fi-rr-menu-dots-vertical mt-2 agent-option"></i>
                    </DropdownToggle>
                    <DropdownMenu className="agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                        {
                            leadMenus && 
                            leadMenus.map((option, index) => {
                                let label = option.label;
                                let value = option.to;
                                return (
                                    <DropdownItem 
                                        className="dropdown-list" 
                                        onClick={e => onMenuChange(value)}
                                    >
                                        <span>
                                            {label}
                                        </span>
                                    </DropdownItem>
                                )
                            })
                        }
                    </DropdownMenu>
                </UncontrolledDropdown>            
            </>
        )
    }
    const getListHeaderContent = () => {

        return (
            <Fragment>
                <div className={`listheader-content p-fixed d-flex col-md-6 m-2 justify-end align-center ${isMobile() ? "mobile-contacts" : ""} ${isMoreOption ? "visible" : "hide"}`}>
                    <Col md={3} className='btn-width custom-3-col-md-3 mb-btn d-flex justify-content-end'>
                        <Button size="lg" className='custom-btn-1' color="dark" onClick={onUpdateContacts}><i class="fi fi-sc-pencil"></i> Update</Button>
                    </Col>
                    <Col md={3} className='btn-width custom-3-col-md-3 mb-btn d-flex justify-content-end'>
                        <Button size="lg" className='custom-btn-1' color="dark" onClick={() => onDeleteContacts(selectedRows)}><i class="fi fi-ss-trash"></i> Delete </Button>
                    </Col>
                </div>
                <div className={`listheader-content d-flex col-md-10 justify-end align-center m-1 ${!isMoreOption ? "visible" : "hide"}`}>
                    <Col md={4} className='btn-width custom-col-md-4'>
                        <div className="dropdown-container pe-2">
                            <Select
                                placeholder="Filter by Lists"
                                name="list_form"
                                id="list_form"
                                className=""
                                classNamePrefix="sub-select wa-select"
                                value={deflistOptions}
                                options={listOptions}
                                onChange={(e) => onStatusChange(e, "list_status")}
                                isClearable={true}
                                />
                        </div>
                        {/* <Button size="lg" className='theme-bg-g ' color="dark" onClick={(e) => handleStatusChanges("Tags")}><i class="fi fi-sc-pencil"></i> Filter by Tag</Button> */}
                    </Col>
                    <Col md={4} className='btn-width custom-col-md-4'>
                        <div className="dropdown-container pe-2">
                            <Select
                                placeholder="Filter by Tags"
                                name="tag_form"
                                id="tag_form"
                                className=""
                                classNamePrefix="sub-select wa-select"
                                value={defTagOptions}
                                options={tagOptions}
                                onChange={(e) => onStatusChange(e, "tag_status")}
                                isClearable={true}    
                                />
                        </div>
                        {/* <Button size="lg" className='theme-bg-g ' color="dark" onClick={(e) => handleStatusChanges("Lists")}><i class="fi fi-ss-trash"></i> Filter by List</Button> */}
                    </Col>
                    <Col md={4} className='btn-width custom-2-col-md-4'>
                        <div className="dropdown-container pe-2">
                            <Select
                                placeholder="Filter by Status"
                                name="contact_status"
                                id="contact_status"
                                className=""
                                classNamePrefix="wa-select"
                                value={defaultStatus}
                                options={allStatus}
                                onChange={(e) => onStatusChange(e, "contact_status")}
                                isClearable={true}
                                />
                        </div>
                        {/* <Button size="lg" className='theme-bg-g ' color="dark" onClick={(e) => handleStatusChanges("Status")}><i class="fi fi-ss-trash"></i> Filter by Status</Button> */}
                    </Col>
                    {/* <Col md={3} className='btn-width custom-1-col-md-3 pl-2'>
                        <Button size="lg" className='theme-bg-g ' color="dark"><i class="fi fi-ss-trash"></i> Search</Button>
                    </Col> */}
                </div>
            </Fragment>
        )

    }


    const handleSelectedRowsChange = (selectedRowsState) => {
        // setSelectedRows(selectedRowsState.selectedRows);
        const selectedDataRows = selectedRowsState.selectedRows
        .filter(row => row.data_row !== undefined && row.data_row !== null && row.data_row !== "")
        .map(row => row.data_row);
        setSelectedRows(selectedDataRows);
        setIsMoreOptionNeeded(selectedDataRows.length > 0);
    };

    const onFormSubmit = () => {

    }

    return (
        <Fragment>
            <Common title={"Leads"}
                titleContent={
                    <span>Leads<span class="count">{data.length}</span></span>
                }
                titleBody={
                    isAdmin && !isMobile() && getHeaderTitleBody(isAddContact)
                }
                mainContent={
                    <Fragment>
                        <div className='main-table-list w-100'>
                            {isOpenForm && formD !== null && <FormModal isModalOpen={isOpenForm} isNew={isNew} onSubmit={onFormSubmit} formId={formId} formDetail={formD} dataRow={dataRow} toggleModal={toggleModal} />}
                            {
                                isMassUpdate && 
                                formD !== null && 
                                <MassUpdateModal
                                    isModalOpen={isMassUpdate}
                                    toggleModal={toggleMassUpdatePanel}
                                    formDetail={formD}
                                    setFormDetail={setFormDetail}
                                    selectedRows={selectedRows}
                                />
                            }
                            <Loading showLoader={showLoading} mainContent={
                                <Fragment>
                                    <div className={`fixed-header-container mb-1 ${isMobile() && 'w-100'}`}>
                                        {
                                            isMobile() && getHeaderTitleBody(isAddContact)
                                        }
                                        <div className='data-container-contacts'>
                                            <ListViewHeader formLabel={""} content={getListHeaderContent()} />
                                        </div>
                                    </div>
                                    <div className={"data-container mt-3 " + (isMobile() ? "lead-table-mobile" : "w-100")}>
                                        <div className={`${recordsPerPage < 15 ? 'contact-data-container-min' : 'contact-data-container'}`}>
                                            {data.length > 0 && column.length ? (
                                                <CustomListTable
                                                    data={data}
                                                    columns={column}
                                                    style={{}}
                                                    isAllowLoadmore = {true}
                                                    handleChange = {handleChange}
                                                    totalRows = {totalRecordsCount}
                                                    tblCurPage = {listTableCurPage}
                                                    recordsPerPage = {recordsPerPage}
                                                    rowOptions = {getPerRecordOption()}
                                                    offSet = {offset}
                                                    isMobile = {isMobile()}
                                                    selectableRows={isAdmin ? true : false}
                                                    clearRows={clearRows}
                                                    onSelectable={handleSelectedRowsChange}
                                                />    
                                                // <ListTable selectableRows={true} clearRows={clearRows} onSelectable={handleSelectedRowsChange} data={data} columns={column} />
                                            ):(
                                                data.length === 0 && !showLoading &&
                                                <NoRecordFound
                                                    img={aiData}
                                                    isOnlyContent={true}
                                                    content={"No Numbers Found."}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </Fragment>
                            } 
                            />
                        </div>
                    </Fragment>
                }
                titleKey={"contact_allowed"}  
            />
        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
